export interface SourcePerformance {
  source: string;
  count: number;
  color: string;
  percentage: number;
}

export interface AccountPerformance {
  account: string;
  sourceGroup: string;
  count: number;
  color: string;
  percentage: number;
}

export const accountPerformanceData: AccountPerformance[] = [
  { account: "IndiaMart - Mumbai", sourceGroup: "IndiaMart", count: 156, color: "bg-indigo-500", percentage: 67 },
  { account: "IndiaMart - Pune", sourceGroup: "IndiaMart", count: 78, color: "bg-indigo-300", percentage: 33 },
  { account: "JustDial - Mumbai", sourceGroup: "JustDial", count: 112, color: "bg-blue-500", percentage: 60 },
  { account: "JustDial - Pune", sourceGroup: "JustDial", count: 75, color: "bg-blue-300", percentage: 40 },
  { account: "TradeIndia - Main", sourceGroup: "TradeIndia", count: 47, color: "bg-orange-500", percentage: 100 },
  { account: "WhatsApp - Sales", sourceGroup: "WhatsApp", count: 134, color: "bg-green-500", percentage: 100 },
  { account: "Website - Main", sourceGroup: "Website", count: 156, color: "bg-purple-500", percentage: 100 },
  { account: "Social - Main", sourceGroup: "Social Media", count: 89, color: "bg-pink-500", percentage: 100 },
];

export interface FunnelStage {
  stage: string;
  count: number;
  percentage: number;
  color: string;
}

export interface AgentPerformance {
  agent: string;
  assigned: number;
  contacted: number;
  converted: number;
  revenue: string;
  revenueRaw: number;
  convRate: number;
}

export interface MonthlyTrend {
  month: string;
  revenue: number;
  leads: number;
}

export const sourcePerformanceData: SourcePerformance[] = [
  { source: "IndiaMart", count: 234, color: "bg-indigo-500", percentage: 100 },
  { source: "JustDial", count: 187, color: "bg-blue-500", percentage: 80 },
  { source: "Website", count: 156, color: "bg-teal-500", percentage: 67 },
  { source: "WhatsApp", count: 134, color: "bg-green-500", percentage: 57 },
  { source: "Social Media", count: 89, color: "bg-pink-500", percentage: 38 },
  { source: "TradeIndia", count: 47, color: "bg-orange-500", percentage: 20 },
];

export const funnelData: FunnelStage[] = [
  { stage: "Total Leads", count: 847, percentage: 100, color: "bg-gray-400" },
  { stage: "Contacted", count: 634, percentage: 75, color: "bg-blue-400" },
  { stage: "Qualified", count: 423, percentage: 50, color: "bg-indigo-500" },
  { stage: "Proposal", count: 267, percentage: 32, color: "bg-purple-500" },
  { stage: "Negotiation", count: 134, percentage: 16, color: "bg-amber-500" },
  { stage: "Closed Won", count: 89, percentage: 11, color: "bg-green-500" },
];

export const agentPerformanceData: AgentPerformance[] = [
  { agent: "Rajesh Kumar", assigned: 312, contacted: 267, converted: 42, revenue: "₹98.4K", revenueRaw: 98400, convRate: 13.5 },
  { agent: "Priya Sharma", assigned: 287, contacted: 245, converted: 31, revenue: "₹76.2K", revenueRaw: 76200, convRate: 10.8 },
  { agent: "Amit Patel", assigned: 156, contacted: 134, converted: 18, revenue: "₹43.1K", revenueRaw: 43100, convRate: 11.5 },
  { agent: "Sneha Rao", assigned: 92, contacted: 78, converted: 8, revenue: "₹21.3K", revenueRaw: 21300, convRate: 8.7 },
];

export interface PipelineVelocityStage {
  stage: string;
  avgTime: string;
  avgTimeHours: number;
  leadsIn: number;
  leadsOut: number | null;
  dropOff: string | null;
  health: "good" | "average" | "slow" | "none";
}

export const pipelineVelocityData: PipelineVelocityStage[] = [
  { stage: "New Inquiry", avgTime: "4.2 hrs", avgTimeHours: 0.175, leadsIn: 847, leadsOut: 712, dropOff: "15.9%", health: "good" },
  { stage: "Site Visit Scheduled", avgTime: "2.1 days", avgTimeHours: 50.4, leadsIn: 712, leadsOut: 534, dropOff: "25.0%", health: "average" },
  { stage: "Site Visit Done", avgTime: "1.3 days", avgTimeHours: 31.2, leadsIn: 534, leadsOut: 423, dropOff: "20.8%", health: "good" },
  { stage: "Proposal Sent", avgTime: "4.8 days", avgTimeHours: 115.2, leadsIn: 423, leadsOut: 267, dropOff: "36.9%", health: "slow" },
  { stage: "Negotiation", avgTime: "6.2 days", avgTimeHours: 148.8, leadsIn: 267, leadsOut: 134, dropOff: "49.8%", health: "slow" },
  { stage: "Booking Done", avgTime: "1.1 days", avgTimeHours: 26.4, leadsIn: 134, leadsOut: 89, dropOff: "33.6%", health: "average" },
  { stage: "Lost", avgTime: "—", avgTimeHours: 0, leadsIn: 158, leadsOut: null, dropOff: null, health: "none" },
];

export interface StaleLeadItem {
  name: string;
  days: number;
  stage: string;
}

export interface ActivityAlert {
  label: string;
  count: number;
  leads: StaleLeadItem[];
}

export const staleLeadsData: StaleLeadItem[] = [
  { name: "Vikram Mehta", days: 8, stage: "Negotiation" },
  { name: "Sunita Rao", days: 12, stage: "Proposal Sent" },
  { name: "Ravi Iyer", days: 7, stage: "Negotiation" },
];

export interface TopSourceData {
  source: string;
  leads: number;
  conversion: number;
  competitors: { name: string; rate: number }[];
}

export const topSourceData: TopSourceData = {
  source: "IndiaMart",
  leads: 234,
  conversion: 18.4,
  competitors: [
    { name: "JustDial", rate: 12.1 },
    { name: "Website", rate: 9.8 },
  ],
};

export interface AgentActivityData {
  agent: string;
  calls: number;
  emails: number;
  whatsapp: number;
  notes: number;
}

export const agentActivityData: AgentActivityData = {
  agent: "Rajesh Kumar",
  calls: 42,
  emails: 18,
  whatsapp: 67,
  notes: 34,
};

export interface ResponseAlertData {
  count: number;
  leads: { name: string; hoursAgo: number; stage: string; assigned: string }[];
}

export const responseAlertData: ResponseAlertData = {
  count: 6,
  leads: [
    { name: "Pooja Menon", hoursAgo: 3, stage: "New Inquiry", assigned: "Sneha Rao" },
    { name: "Arjun Kapoor", hoursAgo: 5, stage: "New Inquiry", assigned: "Amit Patel" },
  ],
};

export const monthlyTrendData: MonthlyTrend[] = [
  { month: "Jan", revenue: 38, leads: 98 },
  { month: "Feb", revenue: 45, leads: 112 },
  { month: "Mar", revenue: 52, leads: 134 },
  { month: "Apr", revenue: 61, leads: 156 },
  { month: "May", revenue: 58, leads: 143 },
  { month: "Jun", revenue: 71, leads: 178 },
];